module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_d3/main_sp_d37f144883ae1e4e01aca344d2013482.jpg";